import { createContext } from 'react';

const EmisionDocumentosContext = createContext();

export default EmisionDocumentosContext;
